import { Grid, Typography } from "@mui/material";
import { styled, lighten } from "@mui/material/styles";

import { TnAClockingTypeRef } from "../../../models/tna";
import SimplePopover from "../../../reusable-components/SimplePopover/SimplePopover";
import { TNA_CLOCKING_TYPES } from "../../../utils/constants/tna-constants";

const { ClockIn } = TNA_CLOCKING_TYPES;

export const FullCalendarContainer = styled(Grid)(({ theme }) => ({
  height: "100%",
  width: "100%",

  ".fc-event-main": {
    textAlign: "center",
    "& .MuiGrid-root": {
      marginTop: 0,
    },
  },

  ".MuiGrid-root": {
    marginTop: 5,
    // height: "auto",
  },
  ".fc-theme-standard .fc-scrollgrid , .fc-theme-standard td, .fc-theme-standard th": {
    border: "none",
  },
  ".fc th": {
    textAlign: "start",
    color: theme.palette.text.disabled,
  },

  ".fc .fc-daygrid-day-frame": {
    // margin: "0px 5px",
    borderTop: `5px solid ${lighten(theme.palette.text.disabled, 0.7)}`,
    borderBottom: 0,
    borderBottomColor: "darkgray",
    borderLeft: 0,
    borderRight: 0,
  },
  ".fc .fc-daygrid-day.fc-day-today": {
    backgroundColor: "transparent",
    // border: "2px solid darkblue",
    "& .fc-daygrid-day-frame": {
      borderTop: `3px solid ${theme.palette.primary.main}`,
      "& .fc-daygrid-day-number .MuiTypography-root": {
        color: theme.palette.primary.main,
      },
    },
  },
  ".fc .fc-daygrid-day": {
    backgroundColor: "transparent",
    border: 0,
    padding: "10px 5px",
  },
  ".fc .fc-daygrid-day-top": {
    flexDirection: "row",
  },
  ".fc .fc-daygrid-week-number": {
    backgroundColor: theme.palette.background.default,
    color: lighten(theme.palette.text.disabled, 0.4),
    top: "-14px",
  },
  ".fc .fc-daygrid-day-number": {
    width: "100%",
    "& .MuiButtonBase-root": {
      padding: 0,
      minWidth: "unset",
    },
    "& svg": {
      margin: "0px",
    },
  },

  ".fc .fc-col-header-cell": {
    backgroundColor: "transparent",
    border: 0,
  },

  "& .dayCellClass": {
    backgroundColor: "transparent",
  },

  "& .isWeekend": {
    backgroundColor: lighten(theme.palette.secondary.light, 0.9),
  },

  "& .isHoliday": {
    backgroundColor: lighten(theme.palette.error.light, 0.9),
  },
}));

export const Container = styled(Grid)({
  display: "flex",
  flexWrap: "wrap",
  // minWidth: "1170px",
});

export const Day = styled(Grid)({
  minWidth: "80px",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "3px",
  // marginTop: "30px",
});

export const DayWrapper = styled(Grid)({
  // marginTop: 50,
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  flexWrap: "wrap",
});

export const EHStatusIndicator = styled(Grid, {
  shouldForwardProp: (props) => props !== "isRejected" && props !== "isApproved" && props !== "isCancelled",
})<{ isRejected: boolean; isApproved: boolean; isCancelled: boolean }>(
  ({ isApproved, isRejected, isCancelled, theme: { palette } }) => ({
    color: isCancelled
      ? palette.grey[400]
      : isRejected
      ? palette.warning.light
      : isApproved
      ? palette.success.main
      : palette.primary.light,
    textDecoration: isRejected || isCancelled ? "line-through" : "",
    width: "78px",
    padding: "1px",
    textAlign: "center",
    fontWeight: 550,
  })
);

export const DayHeaderContainer = styled(Grid)({
  display: "flex",
  flex: "row",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
});

export const MenuContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
}));

export const ScheduleWrapper = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "flex-start",
  // padding: "0px 3px",
});

export const ClockingsWrapper = styled(Grid)(({ theme }) => ({
  // width: "48%",
  display: "flex",
  flexDirection: "column",
  // padding: "0px 3px",
  alignItems: "flex-end",
  gap: "2px",
  backgroundColor: lighten(theme.palette.primary.light, 0.8),
  borderRadius: "5px",
  height: "fit-content",
}));

export const ClockingsInnerWrapper = styled(Grid)(({ theme }) => ({}));

export const ScheduleCodeWrapper = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  cursor: "pointer",
});

export const DayDate = styled(Grid)({
  display: "flex",
  alignItems: "center",
  // fontWeight: 700,
  // color: "black",
  // opacity: 0.75,
  // fontSize: "1.3rem",
  "& .MuiTypography-root": {
    fontWeight: 600,
  },
});

export const ScheduleCode = styled(Grid)(({ theme }) => ({
  width: "100%",
  padding: "3px",
  "&:hover": {
    cursor: "pointer",
  },
  // fontSize: "1.2em",
  display: "flex",
  justifyContent: "space-between",
  backgroundColor: lighten(theme.palette.primary.light, 0.8),
  borderRadius: "5px",
  "& .MuiTypography-root": {
    // fontWeight: 700,
    color: theme.palette.text.disabled,
  },
}));

export const AbsenceCorrectionBlock = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: 4,
  // width:"48%"
});

export const WorkedHours = styled(Grid)({
  fontSize: "1.1em",
  fontWeight: "bold",
  color: "darkblue",
  "&:hover": {
    cursor: "pointer",
  },
});

export const WorkedDayHours = styled(Grid)({
  fontSize: "1.1em",
  fontWeight: "bold",
  color: "darkblue",
  "&:hover": {
    // cursor: "pointer",
  },
});

export const ExtraHours = styled(Grid)(({ theme }) => ({
  // fontSize: "1.1em",
  // fontWeight: "bold",
  padding: "3px 0px",
  color: theme.palette.primary.main,
  backgroundColor: lighten(theme.palette.primary.light, 0.85),
  borderRadius: "3px",
  // color: "darkblue",
  "&:hover": {
    cursor: "pointer",
  },
}));

export const ClientIconGrid = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  gap: "5px",
});

export const BillableTime = styled(Grid)(({ theme }) => ({
  fontSize: "1.1em",
  fontWeight: "bold",
  // color: "darkblue",
  color: theme.palette.warning.main,
  borderRadius: "3px",
  backgroundColor: lighten(theme.palette.warning.light, 0.75),
  "&:hover": {
    cursor: "pointer",
  },
}));

export const AbsenceCorrections = styled(Grid)(({ theme }) => ({
  fontSize: "1.1em",
  fontWeight: "bold",
  // color: "darkblue",
  color: theme.palette.success.main,
  backgroundColor: lighten(theme.palette.success.light, 0.75),
  borderRadius: "3px",

  "&:hover": {
    cursor: "pointer",
  },

  "& .MuiTypography-root": {
    fontWeight: "bold",
  },
}));

export const BillableTimesContainer = styled(Grid)({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  flexWrap: "wrap",
});

export const Clocking = styled(Grid, {
  shouldForwardProp: (props) => props !== "clockingType" && props !== "isAuto",
})<{ clockingType: TnAClockingTypeRef | null; isAuto: boolean | undefined }>(
  ({ clockingType, isAuto, theme: { palette } }) => ({
    // fontSize: "1.1em",

    fontWeight: "bold",
    "&:hover": {
      cursor: "pointer",
    },
    color: palette.text.primary,
    minWidth: "fit-content",
  })
);

export const PresenceCorrectionsWrapper = styled(Grid)({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  marginTop: "2px !important",
});

export const Presence = styled(Typography)(({ theme }) => ({
  alignSelf: "end",
}));

export const WorkedHoursCorrection = styled(Grid)(({ theme }) => ({
  // alignSelf: "start",
  display: "flex",
  alignItems: "center",
  gap: "4px",
}));

export const TnACellMenu = styled(SimplePopover)({
  position: "relative",
  padding: 0,
  bottom: 5,
  right: 5,
});

export const PublicHolidaysList = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
});
